import BadgeAssigneeHome from '@/screens/BadgeAssigneeHome';

export default function PrivateTabsTeamBadgeBadgeIdAssigneeIndexRoute() {
  return <BadgeAssigneeHome />;
}
